export default "__VITE_ASSET__BJuk8JPN__"